var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('c-header'),(_vm.selectedTab === 'ALL')?_c('c-challenges-list',{attrs:{"tab":"all","sponsored":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }